<template>
  <div>
    <!--
    <b-row>
      <b-col>
        new rules ID
        {{ newRulesIDs }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        deleted rules ID
        {{ deletedRulesIDs }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        changed rules id
        {{ changedRulesIDs }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        inputRules
        {{ inputRules }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        convertedRules
        {{ convertedRules }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        pureRules
        {{ pureRules }}
      </b-col>
    </b-row>
    -->
    <b-card>
      <b-tabs content-class="mt-3" align="center" v-model="tabIndex">
        <b-tab
          :title="tabsTitles[aggKey]"
          v-for="aggKey in rulesAggType"
          :key="aggKey"
        >
          <b-row class="justify-content-end">
            <b-col cols="auto">
              <b-dropdown
                :disabled="
                  (!isAddActive[aggKey]['bounce'] &&
                    !isAddActive[aggKey]['thresh']) ||
                    currentUser.id !== 1
                "
                text="Add rule"
                variant="primary"
              >
                <b-dropdown-item
                  v-for="item in addRuleItems"
                  :key="item.value"
                  :disabled="
                    !isAddActive[aggKey][item.value] || currentUser.id !== 1
                  "
                  @click="addRule(aggKey, item.value)"
                  >{{ item.text }}</b-dropdown-item
                >
              </b-dropdown>
            </b-col>
          </b-row>

          <RulesTable
            :items="convertedRules[aggKey]"
            :loading="loading"
            @delete="deleteRule"
            @change="ruleChange"
          />
        </b-tab>
      </b-tabs>

      <b-row class="justify-content-md-center">
        <b-col cols="2">
          <b-button
            variant="primary"
            x-large
            :disabled="!isRulesChanged || currentUser.id !== 1"
            @click="save()"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import RulesTable from "@/components/Domain/Rules/RulesTable";
import { mapGetters } from "vuex";

const BOUNCE = "bounce";
const THRESH = "thresh";

export default {
  components: { RulesTable },
  // eslint-disable-next-line
  async beforeRouteLeave(to, from, next) {
    if (!this.isRulesChanged) {
      next();
      return;
    }
    if (
      await this.$bvModal.msgBoxConfirm(
        "You changed the rule settings but did not save the changes. Would you like to leave the page?",
        {
          title: "Rules changed",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        }
      )
    ) {
      next();
    } else {
      next(false);
    }
  },
  data() {
    return {
      tabIndex: 0,
      loading: false,
      calendar: false,
      inputRules: [],
      rulesAggType: {
        ip: [],
        placement: [],
        range: [],
        user_id: []
      },
      convertedRules: {
        ip: [],
        placement: [],
        user_id: []
      },
      pureRules: {},
      limitsRules: {},
      changedRulesIDs: [],
      deletedRulesIDs: [],
      newRulesIDs: [],
      tabsTitles: {
        ip: "IP Blocking Rules",
        placement: "Placement Blocking Rules",
        range: "Range Blocking Rules",
        user_id: "User Blocking Rules"
      },
      addRuleItems: [
        {
          text: "Bounce",
          value: "bounce"
        },
        {
          text: "Thresh",
          value: "thresh"
        }
      ],
      defaultRules: {
        bounce: {
          title: "Bounce",
          description: "Bounce Descriptions",
          id: null,
          site_id: null,
          class_name: "Bounce",
          agg_type: null,
          inputs: ["thresh", "limit"],
          args: {
            type: ">",
            limit: 4,
            thresh: 15,
            value_type: "value"
          },
          enabled: true,
          deletable: true,
          type: "bounce"
        },
        thresh: {
          title: "Click Threshold",
          description: "Click Threshold Descriptions",
          id: null,
          site_id: null,
          class_name: "ClickThresh",
          agg_type: null,
          inputs: ["limit", "period"],
          args: {
            limit: 5,
            period: 86400
          },
          enabled: true,
          deletable: true,
          type: "thresh"
        }
      }
    };
  },
  watch: {
    async selectedDomains() {
      await this.loadData();
    }
  },
  computed: {
    ...mapGetters(["currentUser"]),
    selectedDomains() {
      return this.$store.state.auth.selectedDomains;
    },
    isRulesChanged() {
      return (
        this.changedRulesIDs.length ||
        this.deletedRulesIDs.length ||
        this.newRulesIDs.length
      );
    },
    isDeletable: {
      get() {
        let returnObject = {};
        this.rulesAggType.forEach(type => {
          returnObject[type] = {
            bounce:
              this.limitsRules[type] &&
              this.limitsRules[type].bounce <= 5 &&
              this.limitsRules[type].bounce > 1,
            thresh:
              this.limitsRules[type] &&
              this.limitsRules[type].thresh <= 5 &&
              this.limitsRules[type].thresh > 1,
            limit: false
          };
        });

        return returnObject;
      }
    },
    isAddActive: {
      get() {
        let returnObject = {};
        this.rulesAggType.forEach(type => {
          returnObject[type] = {
            bounce:
              this.limitsRules[type] &&
              this.limitsRules[type].bounce < 5 &&
              this.limitsRules[type].bounce >= 1,
            thresh:
              this.limitsRules[type] &&
              this.limitsRules[type].thresh < 5 &&
              this.limitsRules[type].thresh >= 1,
            limit: false
          };
        });

        return returnObject;
      }
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    cloneObject(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    addRule(tab, type) {
      const newRule = this.cloneObject(this.defaultRules[type]);
      const timestamp = +new Date();
      newRule.id = "new" + timestamp;
      newRule.new = true;
      newRule.site_id = this.selectedDomains.map(el => el.id)[0];
      newRule.agg_type = tab;

      this.convertedRules[tab].push(newRule);
      this.pureRules[tab].push(this.cloneObject(newRule));
      this.newRulesIDs.push(newRule.id);
      this.updateLimits();
    },
    deleteRule(obj) {
      const id = obj.id;
      const type = obj.agg_type;
      const rule = this.convertedRules[type].find(item => item.id === id);
      const aggType = obj.agg_type;
      this.convertedRules[type] = this.convertedRules[type].filter(
        item => item.id !== id
      );
      this.pureRules[type] = this.pureRules[type].filter(
        item => item.id !== id
      );

      this.inputRules[aggType] = this.inputRules[aggType].filter(
        item => item.id !== id
      );
      this.newRulesIDs = this.newRulesIDs.filter(item => item !== id);
      this.changedRulesIDs = this.changedRulesIDs.filter(item => item !== id);
      if (!rule.new) {
        this.deletedRulesIDs.push(id);
      }
      this.updateLimits();
    },
    async save() {
      if (this.currentUser.id !== 1) {
        return;
      }
      let addRules = [];
      let updateRules = {};
      let processingRule = {};
      if (this.deletedRulesIDs.length) {
        this.sendDeleteRules();
      }
      this.rulesAggType.forEach(type => {
        this.convertedRules[type].forEach(rule => {
          processingRule = this.cloneObject(rule);
          processingRule = this.unconvertObject(processingRule);
          if (rule.new) {
            addRules.push(processingRule);
          } else {
            let key = rule.id + "";
            updateRules[key] = processingRule;
          }
        });
      });
      if (addRules.length) {
        await this.sendAddRules(addRules);
      }
      if (Object.keys(updateRules).length) {
        await this.sendUpdateRules(updateRules);
      }
      this.eraseAll();
    },
    eraseAll() {
      this.deletedRulesIDs = [];
      this.newRulesIDs = [];
      this.changedRulesIDs = [];
      this.loadData();
    },
    async sendDeleteRules() {
      try {
        await this.$api.domain.deleteRules({
          site_id: this.selectedDomains.map(el => el.id)[0],
          ids: this.deletedRulesIDs
        });
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async sendAddRules(rules) {
      try {
        await this.$api.domain.addRules({
          site_id: this.selectedDomains.map(el => el.id)[0],
          rules: rules
        });
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    saveAndCalc() {
      this.save();
    },
    ruleChange(obj) {
      const id = obj.id;
      const type = obj.agg_type;
      const currentRule = this.convertedRules[type].find(
        item => item.id === id
      );
      const pureRule = this.pureRules[type].find(item => item.id === id);

      if (
        pureRule.enabled !== currentRule.enabled ||
        JSON.stringify(pureRule.args) !== JSON.stringify(currentRule.args)
      ) {
        this.changedRulesIDs.push(id);
        this.changedRulesIDs = [...new Set(this.changedRulesIDs)]; // уникальность для массива
      } else {
        this.changedRulesIDs = this.changedRulesIDs.filter(item => item !== id);
      }
    },
    async loadData() {
      this.inputRules = [];
      this.loading = true;
      try {
        const { rules } = await this.$api.domain.getRules({
          site_id: this.selectedDomains.map(el => el.id)[0]
        });
        this.inputRules = rules;
        this.rulesAggType = Object.keys(this.inputRules);
        this.rulesAggType = this.rulesAggType.filter(el => el !== "range");
        this.rulesAggType.forEach(key => {
          this.pureRules[key] = [];
          this.convertedRules[key] = [];
        });
        this.convertRules();
        this.updateLimits();
      } catch (e) {
        switch (e.response?.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async sendUpdateRules(rules) {
      this.loading = true;
      try {
        await this.$api.domain.updateRules({
          site_id: this.selectedDomains.map(el => el.id)[0],
          rules: rules
        });
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    convertRules() {
      let converted = {};
      let convertedPure = {};
      for (let aggType in this.inputRules) {
        // range для внутренних тестов, игнорируем
        if (aggType === "range") {
          continue;
        }

        let rules = this.inputRules[aggType];

        for (let i = 0; i < rules.length; i++) {
          let item = rules[i];

          converted = this.cloneObject(item);
          convertedPure = this.cloneObject(item);

          converted = this.convertObject(converted);
          convertedPure = this.convertObject(convertedPure);

          this.convertedRules[aggType].push(converted);
          this.pureRules[aggType].push(convertedPure);
        }
      }
    },
    convertObject(obj) {
      obj.new = false;
      obj.type = "limit";
      if (obj.inputs.includes("period")) {
        obj.type = THRESH;
      }
      if (obj.inputs.includes("thresh")) {
        obj.type = BOUNCE;
      }
      obj.args = this.cloneObject(obj.args); // сбрасываем привязку
      return obj;
    },
    updateLimits() {
      let limits = {};
      this.rulesAggType.forEach(type => {
        limits[type] = {
          bounce: 0,
          thresh: 0
        };
        this.convertedRules[type].forEach(rule => {
          if (rule.type.includes(BOUNCE) || rule.type.includes(THRESH)) {
            limits[type][rule.type]++;
          }
        });
      });
      this.limitsRules = limits;
    },
    unconvertObject(obj) {
      delete obj.type;
      if (obj.new) {
        delete obj.id;
      }
      delete obj.new;
      return obj;
    }
  }
};
</script>

<style>
*[role="tooltip"] {
  opacity: 1;
}
</style>
